export enum ActualsEnum {
  OneMonth = 1,
  ThreeMonth = 3,
  SixMonth = 6,
  TwelveMonth = 12
}